import { render, staticRenderFns } from "./BlockType14List.vue?vue&type=template&id=6f915f6a&scoped=true&"
import script from "./BlockType14List.vue?vue&type=script&lang=ts&"
export * from "./BlockType14List.vue?vue&type=script&lang=ts&"
import style0 from "./BlockType14List.vue?vue&type=style&index=0&id=6f915f6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f915f6a",
  null
  
)

export default component.exports